import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "h3 mb-3 fw-normal" }, "Please register", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("button", {
  class: "w-100 btn btn-lg btn-primary",
  type: "submit"
}, "Register", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submit && $setup.submit(...args)), ["prevent"])),
    class: "form-signin w-100 m-auto"
  }, [
    _hoisted_1,
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.data.name) = $event)),
      class: "form-control",
      placeholder: "Name"
    }, null, 512), [
      [_vModelText, $setup.data.name]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.data.email) = $event)),
      type: "email",
      class: "form-control",
      placeholder: "name@example.com"
    }, null, 512), [
      [_vModelText, $setup.data.email]
    ]),
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.data.password) = $event)),
      type: "password",
      class: "form-control",
      placeholder: "Password"
    }, null, 512), [
      [_vModelText, $setup.data.password]
    ]),
    _hoisted_2
  ], 32))
}